<template>
  <v-container>
    <h1>Administrasjon for {{ organization.name }}</h1>

    <v-card class="lighten-5 orange mt-5" elevation="3">
      <v-card-title class="white--text orange"> Seksjoner </v-card-title>

      <v-container>
        <v-row>
          <v-col>
            <v-card>
              <v-card-title>
                <v-icon class="mr-2">mdi-store</v-icon>
                Butikker
              </v-card-title>

              <v-card-text>
                Administrer dine
                <router-link :to="{ name: 'adminVendors' }"
                  >butikker</router-link
                >
              </v-card-text>
            </v-card>
          </v-col>

          <v-col>
            <v-card>
              <v-card-title>
                <v-icon class="mr-2">mdi-cash</v-icon>
                Betalingsmetoder
              </v-card-title>

              <v-card-text>
                Konfigurer dine
                <router-link :to="{ name: 'adminPaymentConfiguration' }"
                  >betalingsmetoder</router-link
                >
              </v-card-text>
            </v-card>
          </v-col>

          <v-col>
            <v-card>
              <v-card-title>
                <v-icon class="mr-2">mdi-truck</v-icon>
                Leveringsmetoder
              </v-card-title>

              <v-card-text>
                Konfigurer dine
                <router-link :to="{ name: 'adminDeliveryMethods' }"
                  >leveringsmetoder</router-link
                >
              </v-card-text>
            </v-card>
          </v-col>

          <v-col>
            <v-card>
              <v-card-title>
                <v-icon class="mr-2">mdi-cog</v-icon>
                Innstillinger
              </v-card-title>

              <v-card-text>
                Konfigurer dine
                <router-link :to="{ name: 'adminOrganizationSettings' }"
                  >innstillinger</router-link
                >
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-card class="lighten-5 orange mt-5" elevation="3">
      <v-card-title class="white--text orange">
        <v-icon color="white" class="pr-2">mdi-store</v-icon>
        Butikker
      </v-card-title>

      <v-container>
        <v-row>
          <v-col
            v-for="vendor in vendors"
            :key="vendor.id"
            xs="12"
            sm="6"
            md="4"
            lg="3"
            xl="2"
          >
            <v-card>
              <v-card-title>
                <router-link
                  :to="{
                    name: 'adminVendorDetail',
                    params: { vendorId: vendor.id.toString() },
                  }"
                  >{{ vendor.name }}</router-link
                >
              </v-card-title>

              <v-card-text>Some text here about the vendor</v-card-text>

              <v-card-actions>
                <v-btn
                  :to="{
                    name: 'adminOrders',
                    params: { vendorId: vendor.id.toString() },
                  }"
                >
                  Ordre
                </v-btn>

                <v-btn
                  :to="{
                    name: 'adminProducts',
                    params: { vendorId: vendor.id.toString() },
                  }"
                >
                  Produkter
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import backend from "@/backend";

export default {
  name: "Admin",

  data: function () {
    return {
      vendors: [],
    };
  },

  computed: {
    organization() {
      return this.$store.state.auth.organization;
    },
  },

  async created() {
    this.vendors = await backend.get("vendors/", {
      organization: this.organization.id,
    });
  },
};
</script>

